export default __webpack_public_path__ + "static/media/twitter_dark.e235a412.png";